<template>
  <div class="geren">
    <div class="gerenzheng-cont">
      <!-- 标题    -->
      <div class="gerenz-cont-title">
        <span>账号认证信息</span>

        <span v-if="status == 0" class="shenheloding renz-he">[审核中]</span>
        <span v-if="status == 1" class="shenheyes renz-he">[审核通过]</span>
        <span v-if="status == -1" class="shenheno renz-he">[审核未通过]</span>
      </div>
      <div class="gerenbot">
        <!-- 上半部分列表 -->
        <div class="geren-cont-list-top">
          <!-- 参赛单位 -->
          <div class="geren-cont-list-right-sel">
            <span>参赛单位</span>
            <div class="kongssc"></div>
            <el-select
              id="gerenrenz-sel-company"
              value-key="id"
              v-model="gerenvalue"
              placeholder="请选择"
              :disabled="disabledg"
            >
              <el-option
                v-for="item in gerenoption"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 账号信息填写-->
          <div class="cs-inp gerenz-inp">
            <div class="geren-inp-user">
              <span>账号ID</span>
              <el-input :disabled="true"  placeholder="账号ID" v-model="gruser"></el-input>
            </div>
            <div class="geren-inp-pswoder">
              <span>账号密码</span>
              <el-input
                placeholder="账号密码"
                v-model="grword"
                show-password
                :disabled="true"
              ></el-input>
            </div>
            <div class="geren-inp-emil">
              <span>邮箱地址</span>
              <el-input :disabled="zhengdis"  placeholder="邮箱地址" v-model="gerenemil"></el-input>
            </div>

            <div class="geren-inp-name">
              <span>个人姓名</span>
              <el-input :disabled="disabledg" placeholder="个人姓名" v-model="gerenname"></el-input>
            </div>
            <div class="geren-inp-zhicheng">
              <span>个人职称</span>
              <el-input :disabled="disabledg" placeholder="个人职称" v-model="gerenzhicheng"></el-input>
            </div>
            <div class="geren-inp-phone">
              <span>手机号</span>
              <el-input :disabled="disabledg" placeholder="手机号" v-model="gerenphone"></el-input>
            </div>
          </div>
          <!-- 个人简介和工作证件 -->
          <div class="geren-text">
            <!-- 个人简介 -->
            <div class="geren-text-jianjie">
              <span>个人简介</span> <br />
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="gerentext"
                maxlength="66字"
                show-word-limit
                :rows="8"
                :cols="20"
                :disabled="disabledg"
              >
              </el-input>
            </div>
            <!-- 工作证上传 -->
            <div class="geren-text-zheng">
              <span>工作证件</span>
              <div class="geren-text-zheng-uplode">
                <el-upload
                  class="avatar-uploader"
                  :action="imgurl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  accept=".jpg,.jpeg,.png"
                  :disabled="zhengdis"
                >
                  <!--  :before-upload="beforeAvatarUpload"上传前钩子函数 -->
                  <img v-if="grurltwo" :src="grurltwo" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <!-- 提交按钮 -->
        <div v-show="grbtn"  class="gerenzxbtn">
          <div @click="againbtn()" class="gerenzxbtn-con">
            <el-button type="primary">立即提交</el-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import gerenrenz from "../css/GeRenrenz.css";
export default {
  data() {
    return {
        gerenposturl:'', //上传图片地址
        grurltwo:'',//展示的图片
        gerentext:'', //简介
        gerenphone:'',
        gerenzhicheng:'',
        gerenname:'',
        gerenemil:'',
        grword:'',
        gruser:'',
        gerenvalue:'',//参赛单位
        gerenoption:[],//总参赛单位
        grbtn:false,//提交按钮
        disabledg:true, //输入框默认无法修改
        files:'',
        tokens:JSON.parse(localStorage.getItem("userinfo")).token,
        imgurl:this.$apiUrl+'/index.php/index/upload',
        imgh:'', //上传工作证之后返回的地址
        status:JSON.parse(localStorage.getItem('grxinxi')).status,
        zhengdis:false

    }
  },
  methods:{
      handleAvatarSuccess(res,file){
this.grurltwo = URL.createObjectURL(file.raw);
//后台返回的工作证地址
this.imgh = res.msg;

      },
      beforeAvatarUpload(file){
        this.files = file;
      },

    gerenrz(){
        //   数据赋予
        let grxinxi = this.$store.state.grxinxi;
        this.gerenvalue = grxinxi.work_unit;
        this.gruser = grxinxi.username;
        //   this.grword = grxinxi.username; //无密码
        this.gerenemil = grxinxi.email;
        this.gerenname = grxinxi.name;
        this.gerenzhicheng = grxinxi.title;
        this.gerenphone = grxinxi.phone;
        this.gerentext = grxinxi.message;

        //当审核失败的时候才进入可编辑状态

        if (this.$store.state.status == -1) {
          this.gerenvalue = '';
            this.grbtn = true;
            this.disabledg = false;
            axios({
              method:'get',
              url:this.$apiUrl+'/index.php/index/school',
              params:JSON.parse(localStorage.getItem("userinfo")).token
            }).then(res =>{
              this.gerenoption = res.data.data;
            }).catch(error=>{
               console.log(error);
              })
        }
    },
    // 重新提交认证信息
    againbtn(){

     let work_unit = this.gerenvalue.name;

      if (work_unit ='' ||work_unit == undefined) {
        this.$message.error({
          message:'请选择您的参赛单位！！！',
          offset:200
        })

      }else{

       let phone = this.gerenphone;
      let message = this.gerentext;
      let work_unit_id = this.gerenvalue.id;
      let work_unit = this.gerenvalue.name;
      let email = this.gerenemil;

      let fa = new window.FormData;
      fa.append('phone',phone);
      fa.append('message',message);
      fa.append('image',this.imgh);

      fa.append('work_unit_id',work_unit_id);
      fa.append('work_unit',work_unit);
      fa.append('token',this.tokens);
      fa.append('email',email);
      axios({
        method:'post',
        url:this.$apiUrl+'/index.php/Teacher/check',
        data:fa,

      }).then(res =>{
        // console.log(res.data);
        if (res.data.code == 1) {
          this.$message({
            message:'提交成功，请等待审核',
            offset:200,
            type:'success'
          })
        this.$router.push({path:'/'});
        this.$router.go(0);
        }else if (res.data.code == 0) {
           this.$message.error({
             message:res.data.msg,
             offset:200
           })
        }

      })
       }
    }
  },
  mounted(){
    this.gerenrz();
    //工作证展示
    this.grurltwo = 'http://ke.yunlearning.com:8081'+JSON.parse(localStorage.getItem('grxinxi')).image;
    // 信息审核通过后工作证禁止
    let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状态
    if (rzstutas == 1 || rzstutas==0) {
      this.zhengdis = true;
    }else if (rzstutas == -1) {
       this.zhengdis = false;
      this.grurltwo = '';
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/GeRenrenz.vue